export default "__VITE_PUBLIC_ASSET__f51e0f6d__"